class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (this.detailsContainer) {
      this.detailsContainer.addEventListener(
        'keyup',
        (event) =>
          event.code &&
          event.code.toUpperCase() === 'ESCAPE' &&
          this.close()
      );
    }

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );
      this.summaryToggle.setAttribute('role', 'button');
    }

    const closeBtn = this.querySelector('button[type="button"]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.close.bind(this));
    }

    const resetBtn = this.querySelector('button[type="reset"]');
    if (resetBtn) {
      resetBtn.addEventListener('click', this.reset.bind(this));
    }
  }

  // ...rest of your methods stay the same
  
}
document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get('search-modal')) {
    customElements.define('search-modal', SearchModal);
  }
});
